module.exports = __webpack_public_path__ + "img/csa_button_numberchamps.5f966125.png";